import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import ArrowRightSvg from '@/assets/ArrowRight.svg';

const ArrowRight = ({ size, variant, className }: IconProps) => (
  <img
    src={ArrowRightSvg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default ArrowRight;
